export default __webpack_public_path__ + "static/01_peeker-7a99f689f000caaa0f87a8473e6c3c0a.gif";